import React, { PureComponent } from 'react';
import classNames from 'classnames';

export type PROPS = {
  /** Completed progress */
  completedProgress?: number,
  /** Set error css class if errorBar is true */
  errorBar?: boolean
  /** Progress label text position */
  progressLabelPosition: string
  /** Current progress */
  progress?: number,
  /** Progress label placement */
  progressLabelPackRight?: boolean,
  /** Progressbar infinite animation */
  infiniteAnimation?: boolean
};

export type STATE = {
  completedProgress: number,
  progress: number
};

class GridProgressBar extends PureComponent<PROPS, STATE> {
  static defaultProps = {
    errorBar: false,
    infiniteAnimation: false,
    progressLabelPosition: 'right'
  };

  public state: STATE = {
    completedProgress: this.props.completedProgress ? this.props.completedProgress : 0,
    progress: this.props.progress ? this.props.progress : 0
  };

  render = () => {
    const {
      errorBar,
      infiniteAnimation,
      progressLabelPosition,
      progressLabelPackRight
    } = this.props;

    const {
      completedProgress,
      progress
    } = this.state;

    const progressClasses = classNames(
      'tp-progressbar-wrap',
      {
        'tp-label-inside': progressLabelPosition && progressLabelPosition === 'inside',
        'tp-label-right': progressLabelPosition && progressLabelPosition === 'right',
        'tp-label-bottom': progressLabelPosition && progressLabelPosition === 'bottom',
        'tp-label-top': progressLabelPosition && progressLabelPosition === 'top',
        'tp-errorBar': errorBar,
        'tp-infinite-animation-progressbar': infiniteAnimation
      }
    );

    const progressLabelPack = classNames(
      'tp-label tp-label-progressbar',
      {
        'tp-label-right': progressLabelPackRight
      }
    );

    let progressLabel = (
      <div
        className={progressLabelPack}
      >{completedProgress}%</div>
    );

    return (
      <div className={progressClasses}>
        {progressLabelPosition === 'right' && !infiniteAnimation ? progressLabel : null}
        {progressLabelPosition === 'bottom' && !infiniteAnimation ? progressLabel : null}
        {progressLabelPosition === 'top' && !infiniteAnimation ? progressLabel : null}
        <div className='tp-progressbar'>
          {infiniteAnimation ? <div className={'tp-progress'} /> : (
            <>
              <div
                className={'tp-completed-progress'}
                style={{ width: completedProgress + '%' }}
              >
                {progressLabelPosition === 'inside' ? progressLabel : null}
              </div>
              <div
                className={'tp-progress'}
                style={{ width: progress + '%' }}
              />
            </>
          )}
        </div>
      </div>
    );
  };

  addProgress = (addPercents: number) => {
    let progress = this.state.progress;
    progress = progress + addPercents;

    if (progress > 100) {
      progress = 100;
    }

    this.setState({ progress });
  };

  updateProgress = (progress: number) => {
    if (progress > 100) {
      progress = 100;
    }
    this.setState({ progress });
  };
}

export default GridProgressBar;
